var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:{active: _vm.isNavActive}},[_c('eb-link',_vm._g(_vm._b({class:{'nav-link': true, active: _vm.isNavActive}},'eb-link',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }